import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserStore } from '@stores/user.store';
import { AuthService } from '../../auth/services/auth.service';
import { hasAuthToken } from '../../auth/services/auth.utils';

export const AffiliateLandingGuard: CanActivateFn = async route => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const authService = inject(AuthService);
  const apiKey = route.queryParamMap.get('ApiKey') || route.queryParamMap.get('apiKey');

  if (apiKey) {
    await authService.exchangeAndStoreApiKey(apiKey);
  }

  if (hasAuthToken()) {
    await userStore.waitForLoading();
  }

  return userStore.isLoggedIn() ? true : router.parseUrl('/affiliate-program');
};
